module.exports = __webpack_public_path__ + "img/arrow.77283e29.svg";